import { jsxs, jsx } from 'react/jsx-runtime';
import { useBoolState } from '@fabric-app/hooks/useBooleanState';
import { Button } from '@fabric-app/ui/components/Button';
import Badge from '@fabric-app/ui/components/Badge';
import { useResourceListPreferencesContextUnsafe } from '../resources/components/ResourceList/contexts/resourceListContextPreferences.js';
import { IconNavigational24Filter } from '@fabric-app/icons/svg';

const useFilterToggleButton = (filtersAppliedCountOverride) => {
  const ctx = useResourceListPreferencesContextUnsafe();
  const count = filtersAppliedCountOverride || ctx?.filtersAppliedCount || 0;
  const filterVisibilityState = useBoolState(count > 0);
  return {
    ...filterVisibilityState,
    element: /* @__PURE__ */ jsxs(Badge.Container, {
      children: [
        /* @__PURE__ */ jsx(Button, {
          variant: "bg-secondary",
          shape: "square",
          active: filterVisibilityState.value,
          onClick: filterVisibilityState.handleToggle,
          "data-testid": "filters-button",
          children: /* @__PURE__ */ jsx(IconNavigational24Filter, {})
        }),
        Boolean(count > 0) && /* @__PURE__ */ jsx(Badge, {
          variant: "bg-primary-reverse",
          children: count
        })
      ]
    })
  };
};

export { useFilterToggleButton };
//# sourceMappingURL=useFilterToggleButton.js.map
